// extracted by mini-css-extract-plugin
module.exports = {"overdue-badge":"_17FMZ"};